import { FC, useEffect } from "react";
import useAxios from "../../../../hooks/useAxios";
import { IGetStudentPaymentsDetails, IStudentBreakdown, IStudentPaymentsDetail, PaymentSttCode } from "../../../../models/payments.model";
import useLoader from "../../../../hooks/useLoader";
import { getStudentBreakdownDetailsTodo, getStudentPaymentsDetailsTodo } from "../../../../api/payments.api";
import { Table, TableColumnsType } from "antd";
import { useTranslation } from "react-i18next";
import useUtil from "../../../../hooks/useUtil";

interface IProps {
  paymentRecordDetails: IStudentPaymentsDetail[];
};

const PaymentDetailTable: FC<IProps> = ({
                                          paymentRecordDetails,
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();

  const columns: TableColumnsType<IStudentPaymentsDetail> = [
    {
      title: t('student.student.column65'),
      dataIndex: 'paymentTargetCode',
      render: value => getCommonCodeLabel('PA0001', value),
    },
    {
      title: t('student.student.column22'),
      dataIndex: 'semesterName',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
    },
    {
      title: t('student.student.column48'),
      dataIndex: 'monthNameCode',
    },
    {
      title: t('student.student.column81'),
      dataIndex: 'price',
      render: (value: number) => value?.toLocaleString(),
    },
    {
      title: t('student.student.column39'),
      dataIndex: 'discountAmount',
      render: (value: number) => value?.toLocaleString(),
    },
    {
      title: t('student.student.column40'),
      render: value => (value.price - value.discountAmount)?.toLocaleString(),
    },
    // {
    //   title: '합계금액',
    //   key: 'paymentSumAmount',
    //   dataIndex: 'paymentSumAmount',
    //   render: (value: number) => value?.toLocaleString(),
    // },
    {
      title: t('student.student.column4'),
      dataIndex: 'paymentSttCode',
      render: (value, record) => {
        if (record.paymentRecordStatus === 'OK') {
          return getPaymentSttCode(value);
        } else {
          return getCommonCodeLabel('PA0012', record.paymentRecordStatus);
        }
      },
    },
    {
      title: t('class.class.column46'),
      dataIndex: 'successRefundAmount',
      render: (value: number) => value?.toLocaleString(),
    }
  ];


  const getPaymentSttCode = (paymentSttCode: PaymentSttCode) => {
    switch (paymentSttCode) {
      case 'PA':
        return t('student.student.column77');
      case 'CO':
        return t('student.student.column78');
      case 'WA':
        return t('student.student.column79');
      case 'CA':
        return t('student.student.column80');
    }
  };

  return (
    <Table
      className='comm-table__area'
      columns={columns}
      dataSource={paymentRecordDetails}
      pagination={{ pageSize: 99999 }}
    />
  );
};

export default PaymentDetailTable;